import React, { useEffect, useRef, useState } from 'react';
import { createChart, IChartApi, UTCTimestamp, LineWidth } from 'lightweight-charts';
import BottomNavigation from '../components/BottomNavigation';
import Header from '../components/Header';
import info from "/info.svg";
import { useSiteData } from '../context/SiteDataContext';

const Home: React.FC = () => {
  const chartContainerRef = useRef<HTMLDivElement>(null);
  const [, setChart] = useState<IChartApi | null>(null);

  const site = useSiteData();

  async function handlePrediction(prediction: string) {
    if (!site.webApp) return;
    
    const invoiceLinks: { [key: string]: string } = {
      'TON30S:UP': 'https://t.me/$o53laV4IOFBnAgAAfRoI8A_BBgI',
      'TON30S:DOWN': 'https://t.me/$fz75LF4IOFBoAgAA6VSBBoAVIL0',
    };

    const invoiceLink = invoiceLinks[prediction];
    if (!invoiceLink) return;

    await site.webApp.openInvoice(invoiceLink);

  }

  // console.log(chart);
  useEffect(() => {
    if (chartContainerRef.current) {
      const newChart = createChart(chartContainerRef.current, {
        width: chartContainerRef.current.clientWidth,
        height: chartContainerRef.current.clientHeight,
        layout: {
          background: { color: '#0F1620' },
          textColor: '#DDD',
        },
        grid: {
          vertLines: { color: '#2B2B43' },
          horzLines: { color: '#2B2B43' },
        },
        watermark: {
          visible: false,
        },
        timeScale: {
          rightOffset: 0,
          barSpacing: 50,
          fixLeftEdge: true,
          lockVisibleTimeRangeOnResize: true,
          rightBarStaysOnScroll: true,
          borderVisible: false,
        },
      });

      const lineSeries = newChart.addLineSeries({ 
        color: '#2962FF',
        lineWidth: 4 as LineWidth
      });
      
      let initialData = [
        { time: 1529899200 as UTCTimestamp, value: 0.514245 },
        { time: 1529899201 as UTCTimestamp, value: 0.514245 },
        { time: 1529899202 as UTCTimestamp, value: 0.514345 },
        { time: 1529899203 as UTCTimestamp, value: 0.514245 },
        { time: 1529899204 as UTCTimestamp, value: 0.514245 },
        { time: 1529899205 as UTCTimestamp, value: 0.533456 },
      ];

      const areaSeries = newChart.addAreaSeries({
        topColor: 'rgba(80, 168, 235, 0.85)',
        bottomColor: 'rgba(80, 168, 235, 0)',
        lineColor: 'rgba(80, 168, 235, 1)',
        lineWidth: 3,
        crosshairMarkerVisible: false,
      });
      areaSeries.setData(initialData);


      // Create and style the legend
      const legend = document.createElement('div');
      legend.setAttribute('style', `position: absolute; left: 12px; top: 12px; z-index: 1; font-size: 14px; font-family: sans-serif; line-height: 18px; font-weight: 300; color: white;`);
      chartContainerRef.current.appendChild(legend);

      const updateLegend = (param: any) => {
        const validCrosshairPoint = param && param.time;
        const data = validCrosshairPoint ? param.seriesData.get(lineSeries) : initialData[initialData.length - 1];
        
        if (!data) return;
        
        const price = data.value !== undefined ? data.value : data.close;
        legend.innerHTML = `<div style="font-size: 24px; margin: 4px 0px;">TON/USD</div><div style="font-size: 22px; margin: 4px 0px;">${price}</div>`;
      };

      // Initialize legend with the last data point
      updateLegend({ seriesData: new Map([[lineSeries, initialData[initialData.length - 1]]]) });

      newChart.subscribeCrosshairMove(updateLegend);

      setChart(newChart);

      if (site.events.length > 0) {
        site.events.forEach((event) => {
          const newPoint = { time: event.open_timestamp as UTCTimestamp, value: Number(event.index_price) };
          initialData.push(newPoint);
          areaSeries.update(newPoint);
          updateLegend({ seriesData: new Map([[lineSeries, newPoint]]) });
        });
      }

      return () => {
        newChart.remove();
      };
    }
  }, [site.events]);

  return (
    <div className="flex !bg-[#0F1620] flex-col h-screen text-white">
      <div className="flex-1 overflow-y-auto h-full flex flex-col justify-between p-4">
        <Header />
        <div className="rounded-lg mb-4 h-full flex flex-col justify-evenly items-center">
          <div ref={chartContainerRef} className="w-full h-5/6 relative" />
          <p className="text-xs text-gray-400 mt-2 flex items-center justify-center">
            <img src={info} alt="info" className="w-4 h-4 mr-2" />
            Predict TON/USD in 30 seconds to win 5 TUD. Unlock 4.5⭐️ instantly by inviting friends to join the challenge!
          </p>
        </div>

        <div className="flex space-x-4">
          <button className="flex-1 bg-[#50A8EB1A] text-[#50A8EB] py-2 px-4 rounded h-12" onClick={() => handlePrediction('TON30S:DOWN')}>
            ↓ Down
          </button>
          <button className="flex-1 bg-[#50A8EB] text-white py-2 px-4 rounded h-12" onClick={() => handlePrediction('TON30S:UP')}>
            ↑ Up
          </button>
        </div>
      </div>

      <BottomNavigation active="home" />
    </div>
  );
};

export default Home;
